<template>
    <div class="container-fluid w-100 h-100 pb-3" style="overflow-x: hidden">
        <navbar :title="$t('menu.admin_users')" class="mb-1"/>
        <!-- Add certificates for many users at once -->
        <div class="col-sm-12 mt-1">
            <div
                class="data-list-item add"
                @click.stop="addCertificate">
                <div class="item-img-cont add-title">
                    <i class="fa fa-plus"/>
                </div>
                <div class="item-text-cont">
                    <span class="item-title-add">{{ $t('certificate.add_multiple') }}</span>
                    <font-awesome-icon
                        icon="certificate"
                        class="card-body-icon"
                    />
                </div>
            </div>
        </div>

        <user-list
            v-if="!user"
            class="my-2"
            :can-add="false"
            :results="results"
            @edit="editUser"
        />

        <base-modal v-if="user" size="lg" hide-footer @close="closeUserAndUpdate">
            <users-certificate-list
                :user="user"
                class="my-2"
                @edit="editCertificate"
                @add="addCertificate"
            />
        </base-modal>

        <base-modal v-if="certificate" size="xl" hide-footer hide-header @close="certificate = null" prevent-close>
            <certificate-editor
                v-if="certificate"
                :user="user"
                :results="results"
                :certificate="certificate"
                @closeAndUpdate="closeEditorAndUpdate"
            />
        </base-modal>
        <div
            v-if="loading && false"
            id="loader"
            class="spinner"
        />
    </div>
</template>


<script>
import {restApi} from '.././mixins/RestApiMixin'
import UserList from '../user/UserList'
import UsersCertificateList from './UsersCertificateList'
import CertificateEditor from './CertificateEditor'
import Navbar from "@/components/utils/Navbar.vue";
import BaseModal from "@/components/BaseModal";

export default {
    name: 'UsersCertificate',
    components: {BaseModal, Navbar, UserList, UsersCertificateList, CertificateEditor},
    mixins: [restApi],
    data: function () {
        return {
            results: [],
            user: null,
            certificate: null,
            loading: true,
        }
    },
    mounted: function () {
        this.fetchUsers()
    },
    methods: {
        fetchUsers: function () {
            this.loading = true
            this.results = []
            this.restFetch(this.userCompanyUrl, this.handleResponse)
        },

        handleResponse: function (response) {
            this.results = response.data
            if(this.user) {
                this.user = this.results.find(item => this.user.id === item.id)
            }
            this.loading = false
        },

        editUser: function (user) {
            this.user = user
        },
        closeEditorAndUpdate: function () {
            this.certificate = null
            this.closeAndUpdate()
        },
        closeUserAndUpdate: function () {
            this.certificate = null
            this.user = null
            this.closeAndUpdate()
        },
        closeAndUpdate: function () {
            if (this.certificate) {
                this.certificate = null
            } else {
                this.fetchUsers()
            }
        },
        editCertificate: function (certificate) {
            this.certificate = certificate
        },
        addCertificate: function () {
            this.certificate = {
                user: this.user,
                id: -1,
                granted_day: null,
                expiration_day: null,
                type: null
            }
        }
    }
}
</script>
